import script from "./MultiVideoStream.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiVideoStream.vue?vue&type=script&lang=ts&setup=true"

import "./MultiVideoStream.vue?vue&type=style&index=0&id=e1eeeb9e&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1eeeb9e"]])

export default __exports__